import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import fetch from 'isomorphic-unfetch';

//TODO: create singleton instance instead of multiple if this creates issues in nextjs

var apolloClientInstances = {};

/**
 * Creates and configures the ApolloClient
 * @param  {Object} [initialState={}]
 * @param {Object} [initApolloAppState={}]
 * @param {string} [name] - component name to create multiple instances of apollo client
 * @return {ApolloClient<NormalizedCacheObject>} - apollo client instance
 */
function createApolloClient() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initApolloAppState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var name = arguments.length > 2 ? arguments[2] : undefined;
  var cache = new InMemoryCache({
    addTypename: false
  }).restore(initialState);
  cache.writeData({
    data: initApolloAppState
  });
  var bffBaseUrl = '';
  return new ApolloClient({
    ssrMode: typeof window === 'undefined',
    // Disables forceFetch on the server (so queries are only run once)
    link: new HttpLink({
      uri: bffBaseUrl,
      // Server URL (must be absolute)
      credentials: 'include',
      // Additional fetch() options like `credentials` or `headers`
      fetch: fetch
    }),
    cache: cache,
    resolvers: {},
    name: name
  });
}

/**
 * Always creates a new apollo client on the server
 * Creates or reuses apollo client in the browser.
 * @param  {Object} initialState
 * @param {any} initApolloAppState
 * @param {string} instanceName - component name to create multiple instances of apollo client
 * @return {ApolloClient<NormalizedCacheObject>} - apollo client instance
 */
export function initApolloClient(initialState, initApolloAppState, instanceName // pass in instance name to create unique apolloClient instance
) {
  if (!apolloClientInstances[instanceName]) {
    apolloClientInstances[instanceName] = createApolloClient(initialState, initApolloAppState, instanceName);
  }
  return apolloClientInstances[instanceName];
}

// State Management
export var setApolloState = function setApolloState(data, name) {
  var client = initApolloClient({}, {}, name);
  client.writeData({
    data: data
  });
};

// used to read values from cache from helper, util files (non-react components)
export var readQuery = function readQuery(query, name) {
  var client = initApolloClient({}, {}, name);
  return client.readQuery({
    query: query
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/ApolloUtils/index.js
// module id = 3481
// module chunks = 11